import React, {useCallback} from "react";
import styled from "styled-components";
import {useDispatch, useSelector} from "react-redux";
import {hideNotifications} from "./notificationActions"
import CloseOutcome from "../idea/CloseOutcome";
import {borderColour, contentToggleBackgroundColour, subduedTextColour} from "../../style/styleConsts";
import {logAction} from "../../logging/logEvent";
import UpdateOutcome from "../idea/update/UpdateOutcome";

const Portal = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;
`;

const Container = styled.div`
    position: absolute;    
    display: flex;
    align-items: flex-end;
    justify-content: center;
    pointer-events: none;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
`;

const Notification = styled.div`
    display: flex;
    flex-direction: column;
    width: 544px;
    pointer-events: all;
    border: 1px solid ${borderColour};
    border-radius: 4px;
    background-color: ${contentToggleBackgroundColour};
    padding-bottom: 21px;
    margin-bottom: 30px;
`;

const NotificationsContainerTopRow = styled.div`
    display: flex;
    justify-content: flex-end;
    flex-shrink: 0;
    height: 21px;
`;

const NotificationsContainerBottomRow = styled.div`
    margin: 0 18px 0 17px;
`;

const CloseButton = styled.div`
    display: flex;
    font-size: 28px;
    margin-right: 10px;
    justify-self: flex-end;
    cursor: pointer;
    color: ${subduedTextColour};
`;

const NotificationsArea = ({}) => {
    const notifications = useSelector(state => state.notifications);
    const dispatch = useDispatch();

    const onCloseNotification = useCallback(() => {
        logAction({
            type: "NOTIFICATIONS_CLOSED"
        });
        dispatch(hideNotifications());
    }, [dispatch]);

    const outcome = notifications.outcome === "close" ? <CloseOutcome/> : <UpdateOutcome/>;
    return !notifications.isOpen ? null : (
        <Portal>
            <Container>
                <Notification className="t-notifications-area">
                    <NotificationsContainerTopRow>
                        <CloseButton className="t-close-button" onClick={onCloseNotification}>
                            &times;
                        </CloseButton>
                    </NotificationsContainerTopRow>
                    <NotificationsContainerBottomRow>
                        {outcome}
                    </NotificationsContainerBottomRow>
                </Notification>
            </Container>
        </Portal>
    );
};


export default NotificationsArea;
